import React from "react"
import WithChildren from "../models/interfaces"

export enum Align {
    LEFT = "left",
    RIGHT = "right",
    CENTER = "center",
}

export function Col({ size, sizeSmallDown, align, className, children }: ColProps) {
    const styleClasses = className ? [className] : []
    styleClasses.push(`text-${align ? align : Align.LEFT}`)

    if (sizeSmallDown) {
        styleClasses.push(`col-md-${size ? size : 12}`)
        styleClasses.push(`col-${sizeSmallDown}`)
    } else {
        styleClasses.push(`col-${size ? size : 12}`)
    }
    return <div className={styleClasses.join(" ")}>{children}</div>
}

export interface ColProps extends WithChildren {
    size?: number
    sizeSmallDown?: number
    align?: Align
    className?: string
}
